import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SvgIcon } from '@web/shared/ui';
import { HeaderIconComponent } from '../header-icon/header-icon.component';
import { Route, RouterLinkComponent } from '@web/common';

@Component({
  selector: 'app-header-my-profile-link',
  imports: [HeaderIconComponent, RouterLinkComponent],
  templateUrl: './header-my-profile-link.component.html',
  styleUrl: './header-my-profile-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMyProfileLinkComponent {
  protected readonly SvgIcon = SvgIcon;
  protected readonly Route = Route;
}
